export default "/listings/img/preferred.png";